import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import OtpExtendedPopup from './PopUp/OtpExtendedPopup';
import PopUpWithAnimation from '../../Shared/PopUpWithAnimation/PopUpWithAnimation';
import {dwhExtendedOtpButtonClicked} from 'app/Components/Page/SelfCarePage/partials/header/dwhReports';

const SelfcareExtendedOtpButton = (props) => {
  const [showPopup, setShowPopUp] = useState(false);
  const isLoadingNewData = props.isOtpExtendedAuthenticated && props.isLoadingExtendedData;

  useEffect(() => {
    if (isLoadingNewData) {
      setShowPopUp(true);
    }
  }, [isLoadingNewData]);

  const extendedOtpButtonClicked = () => {
    setShowPopUp(true);
    const customerName = props?.selectedSubscriber?.productFirstName + ' ' + props?.selectedSubscriber?.productLastName;
    const subscriber = props?.selectedSubscriber?.productSubscriberNo;
    const idNumber = props?.authentication?.userDetails?.IDNumber;
    const ban = props?.selectedSubscriber?.ban;
    const param9 = subscriber;
    dwhExtendedOtpButtonClicked(props?.worldType, customerName, subscriber, idNumber, ban, param9);
  };

  return (
    <>
      {(props.isOtpAuthenticated || isLoadingNewData) && (
        <>
          <div className='selfcareExtendedOtpButton' onClick={() => extendedOtpButtonClicked()}>
            <Image className='team-icon' src={require('./icon/team.svg')} />
            <p> לצפייה בכל המנויים</p>
            <Image className='arrow-icon' src={require('./icon/arrow-left.svg')} />
          </div>

          <PopUpWithAnimation className='selfcareExtendedOtpPopUp' isShow={showPopup} onClose={() => setShowPopUp(false)}>
            <OtpExtendedPopup setShowPopUp={setShowPopUp} showPopup={showPopup} />
          </PopUpWithAnimation>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
    isOtpAuthenticated: state.authentication.loginData.isOtpAuthenticated,
    isOtpExtendedAuthenticated: state.authentication.loginData.isOtpExtendedAuthenticated,
    isFetchData: state.selfcarePage.isFetchData,
    isLoadingExtendedData: state.selfcarePage.isLoadingExtendedData,
    worldType: state.selfcarePage.epiData.worldType,
    authentication: state.authentication?.loginData,
    selectedSubscriber: state.selfcarePage.selectedSubscriber,
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(SelfcareExtendedOtpButton);
